export class StateSyncSettings {
  syncKey: string;
}
